module.exports = __webpack_public_path__ + "static/media/banner1.990de708.jpg";